import { Injectable } from "@angular/core";
import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: "root",
})
export class PermissionService {
  parseToken: any = jwt_decode(localStorage.getItem("auth-token") ?? "");

  constructor() {}

  hasPermission(permissionData: string[]): boolean {
    let hasAccess = false;
    let permission: string[] = [];
    if (localStorage.getItem("auth-token")) {
      this.parseToken.authorities.forEach((item: any) => {
        permission.push(item.authority);
      });

      for (const permissionValues of permissionData) {
        if (permission.includes(permissionValues)) {
          hasAccess = true;
          break;
        }
      }
    }

    return hasAccess;
  }
}
